
import {defineComponent, PropType } from 'vue'
import { mapActions , mapGetters , mapState } from 'vuex'
import useNotyf from '../../composable/useNotyf'
import { Index , IndexChartTick , IndicesCategories } from "../../types";
import store , { ActionTypes } from "../../store";
import VModal from '../../components/base/modal/VModal.vue'
import VButton from "../../components/base/button/VButton.vue";
import ApexChart from 'vue3-apexcharts'
import moment from 'moment'
import VControl from '../../components/base/form/VControl.vue'
import VTag from '../../components/base/tags/VTag.vue'
import { useRoute , useRouter } from "vue-router";
let labels_array=[1,2,3]
let title_chart='title'

const notyf = useNotyf()

export default defineComponent({
  name: 'StrategyList',
  components: {
    VModal,
    VButton,
    ApexChart,
    VControl,
    VTag
  },
  setup () {
    const router = useRouter()
    return {
      router
    }
  },
  props: {
    list: {
      type: Array as PropType<Index[]>
    },
    index: {
      type: Object as PropType<Index>,
      required: false,
      chart: false,
      modalDelete:false,
      modalChart:false
    },

  },

  emits: ['selectUser'],
  computed: {
    ... mapState( [  'users' , 'user' , 'is_staff' ] ) ,
    ...mapGetters([
      'isStaff'
    ])
  },
  data() {
    return {
      index_chart_tick:{
        chart: false,
        index_id:0
      },
      strat_name:'',
      chart_options: {
        series: [
          {
            data: [

            ],
          },
        ],
        chart: {
          height: 450,
          type: 'line',
          zoom: {
            enabled: true,
          },
          toolbar: {
            show: true,
          },
        },
        colors: ['#039be5'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [2, 2, 2],
          curve: 'smooth',
        },
        title: {
          text: '',
        },
        tooltip: {
          enabled: true,
          followCursor: true,
          style: {
            fontSize: '2rem'
          }
        },
        grid: {
          row: {
            colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          type: 'numeric',
          categories: [],
          //tickPlacement: 'on',
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: true,
            showDuplicates: false,
            trim: false,
            minHeight: undefined,
            maxHeight: 120,
            style: {
              colors: [],
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              cssClass: 'apexcharts-xaxis-label',
            },
            offsetX: 0,
            offsetY: 0,
            formatter: function (value: any) {
              return moment(labels_array[value.toFixed(0)]).format("DD/MM/YYYY, HH:mm");
            },
          },
        },
        yaxis: {
          tickAmount: 1,
        }
      },
      isFullScreen: false,
      copiedCIX: false,
    }
  },
  methods: {
    ... mapActions( {
      fetchStrategies : ActionTypes.FETCH_INDICES ,
    }),
    getChartData( strat_name : string ) {
      store.dispatch( ActionTypes.SET_CHART_DATA , strat_name )
          .then( res => {
            title_chart=strat_name
            labels_array=res.data.chart_data.data_chart_index
            this.chart_options.series[0].data=res.data.chart_data.data_chart
          } )
    },
    updateIsChart (event:boolean, index_id:number,tabvalue:string) {
      let payload = {
        chart : event ,
        index_id : index_id
      }
      console.log( 'TabValue' , tabvalue )
      store.dispatch( ActionTypes.SET_CHART_ENABLED , payload );
      const target = tabvalue
      let value
      switch ( target ) {
        case 'house':
          if ( this.is_staff && !this.users ) {
            store.dispatch( ActionTypes.FETCH_USERS )
          }
          tabvalue = IndicesCategories.HOUSE,
              this.router.push( '/stratslist' )
          break;
        case 'users':
          store.dispatch( ActionTypes.FETCH_USERS )
          tabvalue = IndicesCategories.USERS
          break;
        default:
          if ( this.is_staff && !this.users ) {
            store.dispatch( ActionTypes.FETCH_USERS )
          }
          tabvalue = IndicesCategories.ASSIGNED
          this.router.push( '/stratslist' )
          break
      }
      if ( value === tabvalue ) return
      this.fetchStrategies( tabvalue )
    },
    copyCIXSuccess () {
      this.copiedCIX = true
      const timeoutID = window.setTimeout(() => {
        this.copiedCIX = false
        window.clearTimeout(timeoutID);
      }, 5000)
    },
    delStrategy(index: any) {
      index.modalDelete = false;
      notyf.success(`Strategy deleted`);
      notyf.warning(`Your page will auto-refresh in 3 seconds to update strategies`);
      setTimeout(function () { location.reload(); }, 3000);
    }
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch(ActionTypes.FETCH_PRODUCTS).then(() =>
        store.dispatch(ActionTypes.FETCH_USERS).then(() =>
            store.dispatch(ActionTypes.FETCH_INDICES, IndicesCategories.ASSIGNED).then(() => next())
        )
    )
  }
})
